import type { ComponentType, SVGProps } from "react";
import {
    CsvIcon,
    DocIcon,
    JpgIcon,
    PdfIcon,
    PngIcon,
    PptIcon,
    XlsIcon,
} from "@icons";

const FILE_NAME_PATTERN = /^(.+)\.([a-z]{3,4})$/i;

/** The file-type icon for each lowercase extension we have artwork for. */
export const FILE_TYPE_ICONS: Readonly<
    Partial<Record<string, ComponentType<SVGProps<SVGSVGElement>>>>
> = {
    pdf: PdfIcon,
    doc: DocIcon,
    docx: DocIcon,
    ppt: PptIcon,
    xls: XlsIcon,
    xlsx: XlsIcon,
    png: PngIcon,
    csv: CsvIcon,
    jpg: JpgIcon,
    jpeg: JpgIcon,
};

/** Splits off a 3-4 letter extension after the last dot; `extension` is null without one. */
export const splitFileName = (fileName: string) => {
    const match = FILE_NAME_PATTERN.exec(fileName);
    return match
        ? { name: match[1], extension: match[2] }
        : { name: fileName, extension: null };
};
